// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormFieldStyle } from "@insite/mobius/FormField";
import { IconWrapper } from "@insite/mobius/Icon";
import Search from "@insite/mobius/Icons/Search";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { searchInputStyles } from "@pacific/Overrides/Widgets/Header/SearchInput";
import HeaderUpload from "@pacific/XDL/Icons/HeaderUpload";
import { color, xScreen } from "@pacific/XDL/Utilities";
import { css } from "styled-components";

searchInputStyles.select = {
    cssOverrides: {
        formInputWrapper: css`
            && {
                select {
                    height: 44px;
                }
                ${IconWrapper} {
                    height: 100%;
                    background: transparent;
                }
            }
        `,
    },
};

searchInputStyles.container = {
    css: css`
        display: flex;
        gap: 24px;
        ${xScreen("lte", "sm")} {
            gap: 12px;
        }

        > span {
            flex: 1;
        }
    `,
};

searchInputStyles.inputWrapper = {
    css: css`
        line-height: 0; // to fix extra spacing on firefox
        position: relative;
        text-align: start;
        width: 100%;
        display: flex;
        align-items: center;
        gap: 4px;
        padding-right: 2px;
        border: 1px solid ${color("common.border")};
        background-color: ${color("common.ui1")};
    `,
};

searchInputStyles.fileUploader = {
    buttonProps: {
        icon: { src: HeaderUpload as any, position: "left" },
        css: css`
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            padding: 0 7px;
            margin: 0;
            ${IconWrapper} {
                width: 24px;
                height: 24px;
                & svg {
                    width: 24px;
                    height: 24px;
                }
            }
            ${TypographyStyle} {
                display: none;
            }
        `,
    },
};

searchInputStyles.searchButton = {
    icon: { src: Search, position: "left" },
    css: css`
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        padding: 0 7px;
        margin: 0;
        ${IconWrapper} {
            height: 24px;
            width: 24px;
            & svg {
                width: 24px;
                height: 24px;
            }
        }
    `,
};

searchInputStyles.imageSearchTooltip = {
    cssOverrides: {
        tooltipClickable: css`
            margin: 0;
        `,
    },
};

searchInputStyles.searchTooltip = {
    cssOverrides: {
        tooltipClickable: css`
            margin: 0;
        `,
    },
};

searchInputStyles.input = {
    cssOverrides: {
        formField: css`
            button {
                display: none;
            }
        `,
        inputSelect: css`
            height: 44px;
            border: none;
            &:hover:not(:disabled),
            &:focus:not(:disabled) {
                border: none;
            }
        `,
    },
};
